import { SET_ACTIVE_INVENTORY_TYPE } from '../actions/ActionTypes'
import {
  HANDLE_CLICK,
  HANDLE_HOVER,
  type HandleClickArgs,
  type HandleHoverArgs,
  SET_SVG_INVENTORY,
  SET_INTERACTIVE_FLOORPLAN_DIMENSIONS,
  IS_INTERACTIVE_FLOORPLAN_OPEN,
} from './actions'
import type { SvgInventoryByDate } from './types'

interface InteractiveFloorPlanAction {
  svgInventory: SvgInventoryByDate
  handleClickArgs: HandleClickArgs
  handleHoverArgs: HandleHoverArgs
  isOpen: boolean
  height?: number
  width?: number
  type: string
  svgElement?: HTMLElement
  inventoryIds?: string[]
  date?: string
}

export interface FloorPlanState {
  svgInventory: SvgInventoryByDate
  isOpen: boolean
  height?: number
  width?: number
}

const initialState = {
  svgInventory: {},
  isOpen: false,
}

export const interactiveFloorplan = (state: FloorPlanState = initialState, action: InteractiveFloorPlanAction): FloorPlanState => {
  switch (action.type) {
    case SET_SVG_INVENTORY:
      return { ...state, svgInventory: { ...state.svgInventory, ...action.svgInventory } }
    // handlers use inventory name over id because we need to update a section of items
    case HANDLE_CLICK:
      return {
        ...state,
        svgInventory: {
          [action.handleClickArgs.selectedDate]:
            state.svgInventory[action.handleClickArgs.selectedDate]?.map(inventory => {
              if (!inventory.isActive) {
                return { ...inventory, status: 'default' }
              }
              if (inventory.inventoryName === action.handleClickArgs.inventoryName) {
                return { ...inventory, status: 'click' }
              }
              return { ...inventory, status: 'default' }
            }) || [],
        },
      }
    case HANDLE_HOVER:
      return {
        ...state,
        svgInventory: {
          [action.handleHoverArgs.selectedDate]:
            state.svgInventory[action.handleHoverArgs.selectedDate]?.map(inventory => {
              if (inventory.status === 'click') {
                return inventory
              } else if (action.handleHoverArgs.hover && inventory.inventoryName === action.handleHoverArgs.inventoryName) {
                return { ...inventory, status: 'hover' }
              }
              return { ...inventory, status: 'default' }
            }) || [],
        },
      }
    case SET_ACTIVE_INVENTORY_TYPE: {
      if (!action.date) {
        return state
      }

      const { inventoryIds = [] } = action
      return {
        ...state,
        svgInventory: {
          ...state.svgInventory,
          [action.date]:
            state.svgInventory[action.date]?.map(inventory => ({
              ...inventory,
              isActive: inventoryIds.length > 0 ? inventoryIds.includes(inventory.inventoryId) : true,
            })) || [],
        },
      }
    }
    case SET_INTERACTIVE_FLOORPLAN_DIMENSIONS:
      return {
        ...state,
        height: action.height,
        width: action.width,
      }
    case IS_INTERACTIVE_FLOORPLAN_OPEN:
      return {
        ...state,
        isOpen: action.isOpen,
      }
    default:
      return state
  }
}
